import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Icon } from '../../display/Icon/Icon.es.js';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import { Typography } from '../../../theme/Typography.es.js';
import '../../../theme/ZinniaStylesReset.es.js';
import { ServiceIcon } from '../../patterns/ServiceIcon/ServiceIcon.es.js';

const Styles = labelStyles("ZapCardSteps", {
  root: css`
    border: 1px solid ${Colors.neutral300};
    border-radius: 10px;
  `,
  step: css`
    position: relative;
    display: grid;
    grid-template-columns: max-content 1fr;
    gap: 10px;
    align-items: center;
    padding: 10px;
    ${Typography.smallPrint3};
    color: ${Colors.neutral700};
  `,
  stepName: css`
    ${Typography.smallPrint1Semibold};
    color: ${Colors.neutral800};
  `,
  divider: css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    display: flex;
    align-items: center;

    &::before,
    &::after {
      content: '';
      height: 1px;
      background-color: ${Colors.neutral300};
      flex: 1;
    }

    &::before {
      margin-right: 2px;
    }

    &::after {
      margin-left: 2px;
    }
  `
});
const ZapCardStep = (props) => {
  const isTrigger = props.index === 0;
  const divider = !isTrigger && jsx(
    "div",
    { css: Styles.divider, "data-zds": true },
    jsx(Icon, { color: "gray20", name: "formAddCircle", size: 18 })
  );
  return jsx(
    "li",
    { css: Styles.step, "data-zds": true },
    divider,
    jsx(ServiceIcon, { ariaHidden: true, serviceName: props.name, size: 60, src: props.icon }),
    jsx(
      "div",
      { "data-zds": true },
      jsx("p", { "data-zds": true }, isTrigger ? "When this happens" : "Then do this"),
      jsx(
        "p",
        { css: Styles.stepName, "data-zds": true },
        "Step ",
        props.index + 1,
        ": ",
        props.label
      )
    )
  );
};
const ZapCardSteps = (props) => {
  return jsx("ol", { css: Styles.root }, props.steps.map((step, i) => {
    return jsx(ZapCardStep, Object.assign({}, step, { index: i, key: i }));
  }));
};

export { ZapCardSteps };
//# sourceMappingURL=ZapCardSteps.es.js.map
